import Vue from 'vue'
import Vuex from 'vuex'
import getters from '@/store/getters'

// actions
import actions from '@/store/actions'

// mutations
import mutations from '@/store/mutations'
import modules from '@/store/modules'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    slide: {},
    slides: [],
    idSlide: null,
    audienceId: null,
    audienceName: '',
    audienceEmoji: '',
    audienceQuizTeam: null,
    slideOptions: [],
    isAudienceEmojiDisabled: false,
    quizStatus: 1,
    countdownTimeToAnswer: 0,
    logo: null,
    presentation: {},
    showQaSession: false,
    questions: [],
    tabQnaQuestion: 1,
    questionerName: '',
    questionCount: 0,
    socketDisconnect: false,
    connectionError: false,
    disableScrollBody: false,
    audienceEmail: '',
    audienceTeam: '',
    isAnswerSubmitted: false,
  },
  mutations,
  actions,
  modules,
  getters,
})
